
import Layout from '@/components/Layout';
import SEOHead from '@/components/SEOHead';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const Contact = () => {
  const { language } = useLanguage();

  // Construir ruta localizada
  const getLocalizedPath = (path: string) => {
    return language === 'en' ? `/en${path}` : path;
  };

  return (
    <Layout>
      <SEOHead 
        title="Estancia Corta | Contacto"
        description="¿Tienes alguna pregunta o necesitas ayuda? Estamos aquí para ayudarte a encontrar el alojamiento perfecto para ti."
      />
      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Contacto
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              ¿Tienes alguna pregunta o necesitas ayuda? Estamos aquí para ayudarte. 
              Contáctanos y te responderemos lo antes posible.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Teléfono */}
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <span className="text-2xl">📞</span>
              </div>
              <h3 className="text-xl font-semibold mb-4">Teléfono</h3>
              <p className="text-gray-600">
                <a 
                  href="tel:+523335781778" 
                  className="hover:text-blue-600 transition-colors"
                >
                  +52 3335 78 17 78
                </a>
              </p>
            </div>

            {/* Email */}
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <span className="text-2xl">✉️</span>
              </div>
              <h3 className="text-xl font-semibold mb-4">Email</h3>
              <p className="text-gray-600">
                <a 
                  href="mailto:pdrocb@gmail.com" 
                  className="hover:text-blue-600 transition-colors"
                >
                  pdrocb@gmail.com
                </a>
              </p>
            </div>

            {/* Ubicación */}
            <div className="text-center">
              <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 shadow-lg">
                <span className="text-2xl">📍</span>
              </div>
              <h3 className="text-xl font-semibold mb-4">Ubicación</h3>
              <p className="text-gray-600">
                Jalisco, México
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            ¿Listo para tu próxima aventura?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Explora nuestras propiedades únicas y encuentra el lugar perfecto para tus vacaciones.
          </p>
          <Link 
            to={getLocalizedPath('/propiedades')}
            className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            Ver Propiedades
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
